import React, { useState, useEffect, useContext } from 'react';
import { string, bool, shape } from 'prop-types';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { useLayoutGroupProps } from '@thd-olt-component-react/layout-manager';
import classNames from 'classnames/bind';
import { makeApiRequest, shouldMakeApiRequest } from '../../utils/requestHelpers';
import { getSchema, getSkus, isExperienceDataResolved } from '../../utils/helpers';
import styles from './SponsoredSkyscraperBanner.module.scss';

const isValidScenario = ({ schemaId, lastRequestScenario, experienceContext, pageContext }) => {
  if (schemaId.includes('event_browse_sponsored')) {
    return false;
  }
  return shouldMakeApiRequest({ lastRequestScenario, experienceContext, pageContext });
};

const SponsoredSkyscraperBanner = (props) => {
  const [lastRequestScenario, setLastRequestScenario] = useState({});
  const [hasData, setHasData] = useState(false);
  const { renderTallBanner = true } = useLayoutGroupProps({ props });
  const experienceContext = useContext(ExperienceContext);
  const { pageContext } = props;
  let { schema } = props;
  const cx = classNames.bind(styles);
  const { storeId, isLocalized } = useStore({
    varnish: true,
    online: true,
  });

  experienceContext.useStoreId = storeId;

  schema = getSchema({ schema, pageContext });
  const schemaId = schema + '__skyscraper';

  useEffect(() => {
    const isResolvedContext = isExperienceDataResolved({ isLocalized, experienceContext });

    if (
      renderTallBanner
      && isResolvedContext
      && isValidScenario({ schemaId, lastRequestScenario, experienceContext, pageContext })
    ) {
      setLastRequestScenario({
        url: window.location.pathname + window.location.search,
        skus: getSkus(pageContext),
      });

      makeApiRequest({
        schema,
        schemaId,
        experienceContext,
        pageContext,
        setHasData,
        bannerType: 'skyscraper',
      });
    }
  }, [pageContext.data, isLocalized, experienceContext.mounted]);

  if (!renderTallBanner || !hasData) {
    return null;
  }

  return (
    <div className={cx('sponsored_skyscraper_banner')}>
      <div id={schemaId} />
    </div>
  );
};

SponsoredSkyscraperBanner.propTypes = {
  schema: string,
  pageContext: shape({
    label: string,
    data: shape(),
    keyword: string,
    isSearch: bool,
    isCategory: bool,
    isBrowse: bool,
  }),
};

SponsoredSkyscraperBanner.defaultProps = {
  schema: '',
  pageContext: {},
};

export { SponsoredSkyscraperBanner };
